<template>
    <div>
        <table class="table" v-if="compiledData">
            <thead>
                <tr>
                    <th rowspan="2">Dealer</th>
                    <th :colspan="compiledData[Object.keys(compiledData)[0]].length">Date in Month</th>
                </tr>
                <tr>
                    <th v-for="dealer,index in compiledData[Object.keys(compiledData)[0]]">
                        {{index + 1}}
                    </th>
                </tr>
            </thead>
            <tbody :style="{ 'max-height' : maxHeight + 'px' }">
                <tr v-for="dealer,index in compiledData">
                    <td>{{ index }}</td>
                    <td v-for="item in dealer" :class="{'background-green' : item.count > 0}">{{item.count}}</td>
                </tr>
            </tbody>
        </table>
        <div v-else class="text-center pt-5 pb-5">
            <span class="loading">Loading...</span>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                compiledData : null,

                monthLength : 0,
            }
        },
        props : ['data', 'maxHeight'],
        mounted () {
            this.convertData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'convertData'
            }
        },
        methods : {
            convertData () {
                let data = JSON.parse(JSON.stringify(this.data))

                if (!data) {
                    this.compiledData = null;
                    return;
                }

                let dealers = {}

                for (var i in data) {
                    dealers[data[i].dealer_code] ? dealers[data[i].dealer_code].push(data[i]) : dealers[data[i].dealer_code] = [data[i]];
                }

                this.compiledData = dealers;
            }
        }
    }
</script>

<style scoped>
    table th {
        vertical-align: middle;
    }
    
    .loading{
        color: #616161;
        font-size: 50px;
        text-shadow: 4px 4px 6px #BDBDBD;
    }

    .green {
        color: green;
    }

    .background-green {
        background-color: rgb(158, 202, 158);
    }

    tbody {
        display: block;
        overflow: auto;
    }

    thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }

    thead {
        /* width: calc(100% - 1em); */
    }

    table {
        width: 100%;
    }
</style>